export const noPrintCss = {
  '@media print': {
    display: 'none !important',
  },
}
